// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "styles" + "." + "2abf33edabdf3333f92a" + ".bundle.css";
};